<template>
    <el-row class="el-row-footer">
        <el-col :span="24">
            <div
                style="
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #ffffff;
                    letter-spacing: 0;
                    text-align: center;
                    line-height: 24px;
                    font-weight: 400;
                    margin-top: 26px;
                "
            >
                Copyright © 2020-2021
                复旦大学人文社科“历史GIS与数字人文研究”青年融合创新团队-南京师范大学
                版权所有. 沪ICP备:16018209-1<br />
                地址：上海市邯郸路220号光华楼西主楼2204室
                邮箱：weidongloo@aliyun.com <br />
                最佳浏览分辩率：1920x1200
            </div>
        </el-col>
    </el-row>
</template>


<script>
export default {
    name: 'comFooter',
}
</script>

<style scoped>
.el-row-footer {
    width: 100%;
    height: 109px;
    background-image: url(/static/img/底部背景.png);
}
</style>



// WEBPACK FOOTER //
// src/V3/Footer/comFooter.vue